import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'
import { uniqBy } from 'lodash'

export class FontsStore {
  rootStore: RootStore

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  list(sources?: Array<'blaze' | 'google' | 'custom'>) {
    const fonts = []

    if (sources?.includes('blaze')) {
      fonts.push(...this.rootStore.blazeFonts.list)
    }

    if (sources?.includes('google')) {
      fonts.push(...this.rootStore.googleFonts.list)
    }

    if (sources?.includes('custom')) {
      fonts.push(...this.rootStore.customFonts.list)
    }

    return uniqBy(fonts, 'name').sort((a, b) => a.name.localeCompare(b.name))
  }

  get = (name: string) => {
    return (
      this.rootStore.blazeFonts.get(name) ||
      this.rootStore.googleFonts.get(name) ||
      this.rootStore.customFonts.get(name)
    )
  }

  get ready() {
    return this.rootStore.blazeFonts.ready && this.rootStore.googleFonts.ready
  }
}
